// 设备管理
const equipmentManagementJurisdiction = [
  { id: "003001001", label: "添加设备", children: [] },
  { id: "003001002", label: "删除设备", children: [] },
  { id: "003001003", label: "修改设备", children: [] },
  { id: "003001004", label: "导入设备", children: [] },
  { id: "003001005", label: "导出设备", children: [] },
  { id: "003001006", label: "同步人脸", children: [] }
];

// 门禁授权
const accessControlAuthorityJurisdiction = [
  { id: "003002001", label: "添加授权", children: [] },
  { id: "003002002", label: "删除授权", children: [] },
  { id: "003002003", label: "导出", children: [] }
];

// 人脸门禁授权
const faceAccessControlAuthorityJurisdiction = [
  { id: "003003001", label: "添加授权", children: [] },
  { id: "003003002", label: "删除授权", children: [] },
  { id: "003003003", label: "导出", children: [] }
];
// 门禁一体机
const keypadIntegrationJurisdiction = [
  { id: '003011001', label: '添加授权', children: [] },
  { id: '003011002', label: '删除授权', children: [] },
  { id: '003011003', label: '导出', children: [] }
]
// 授权记录
const authorityRecordJurisdiction = [
  { id: "003004000", label: "导出", children: [] },
  { id: "003004002", label: "重新下发", children: [] },
  { id: "003004003", label: "修改照片", children: [] }
];

// 开门记录
const openingRecordJurisdiction = [
  { id: "003005001", label: "导出", children: [] }
];

// 报警记录
const alarmRecordJurisdiction = [
  { id: "003006001", label: "导出", children: [] }
];

// 状态日志
const statusLogJurisdiction = [
  { id: "003007001", label: "导出", children: [] }
];

// 开门计划
const openDoorsProjectJurisdiction = [
  { id: "003008001", label: "添加开门计划", children: [] },
  { id: "003008002", label: "删除开门计划", children: [] },
  { id: "003008003", label: "修改开门计划", children: [] }
];

// 智慧门禁
const accessControlJurisdictionChildren = [
  {
    id: "003010000",
    label: "概览",
    routerName: "access-over-view",
    children: []
  },
  {
    id: "003001000",
    label: "设备管理",
    routerName: "accessCtrlDeviceManagementCenter",
    children: equipmentManagementJurisdiction
  },
  {
    id: "003002000",
    label: "二维码门禁授权",
    routerName: "app-center-access-ctrl-empowerment",
    children: accessControlAuthorityJurisdiction
  },
  {
    id: "003003000",
    label: "人脸门禁授权",
    routerName: "app-center-access-ctrl-face-authority",
    children: faceAccessControlAuthorityJurisdiction
  },
  {
    id: '003011000',
    label: '门禁一体机',
    routerName: 'app-center-access-ctrl-keypad-integration',
    children: keypadIntegrationJurisdiction
  },
  {
    id: "003004001",
    label: "授权记录",
    routerName: "app-center-access-ctrl-face-issue",
    children: authorityRecordJurisdiction
  },
  {
    id: "003005000",
    label: "开门记录",
    routerName: "app-center-access-ctrl-open-record",
    children: openingRecordJurisdiction
  },
  {
    id: "003006000",
    label: "报警记录",
    routerName: "app-center-access-ctrl-call-police",
    children: alarmRecordJurisdiction
  },
  {
    id: "003007000",
    label: "状态日志",
    routerName: "app-center-access-ctrl-device-status",
    children: statusLogJurisdiction
  },
  {
    id: "003008000",
    label: "开门计划",
    routerName: "app-center-access-ctrl-open-config",
    children: openDoorsProjectJurisdiction
  },
  {
    id: "003009000",
    label: "操作日志",
    routerName: "access-ctrl-log",
    children: []
  }
];

const accessControlJurisdiction = {
  id: "003",
  label: "智慧门禁",
  children: accessControlJurisdictionChildren
};

export { accessControlJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/accessControlJurisdiction.js